import { render, staticRenderFns } from "./PreventingAtrialFibrillation.vue?vue&type=template&id=10c22bdf&scoped=true&"
import script from "./PreventingAtrialFibrillation.vue?vue&type=script&lang=js&"
export * from "./PreventingAtrialFibrillation.vue?vue&type=script&lang=js&"
import style0 from "./PreventingAtrialFibrillation.vue?vue&type=style&index=0&id=10c22bdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c22bdf",
  null
  
)

export default component.exports